import moment from 'moment-timezone';
moment.tz('Europe/Istanbul');
export default moment;
